import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PageBanner } from '../components/PageBanner';
import { BookingCTA } from '../components/BookingCTA';
import { PromoOffers } from '../components/PromoOffers';
import { Button } from '../components/ui/Button';
const categories = [{
  id: 'all',
  name: 'All Services'
}, {
  id: 'braids',
  name: 'Braids'
}, {
  id: 'locs',
  name: 'Locs'
}, {
  id: 'twisted',
  name: 'Twisted Hair Styles'
}, {
  id: 'protective',
  name: 'Protective Hair Styles'
}, {
  id: 'straight',
  name: 'Straight Hair Styles'
}];
const services = [{
  id: 1,
  category: 'braids',
  title: 'Knotless Braids',
  description: 'Pain-free, lightweight braids that protect your edges',
  image: 'https://cdn.magicpatterns.com/uploads/x18s1H3nSx2DtuCH7Jh7VQ/Screenshot_2026-04-01_132232_imgupscaler.ai_Beta_2K_(1).jpg'
}, {
  id: 2,
  category: 'braids',
  title: 'Box Braids',
  description: 'Classic, timeless braids crafted with precision',
  image: 'https://cdn.magicpatterns.com/uploads/boUHQNAWUBwaeKMwwoCfEN/Screenshot_2026-04-01_133246_imgupscaler.ai_Beta_2K.jpg'
}, {
  id: 3,
  category: 'braids',
  title: 'Cornrows',
  description: 'Intricate, neat designs from simple to complex patterns',
  image: 'https://cdn.magicpatterns.com/uploads/8qhgouxowTDJZSK5qxwr4f/unnamed_(5).webp'
}, {
  id: 4,
  category: 'braids',
  title: 'Goddess Braids',
  description: 'Thick braids with curly ends for a bohemian look',
  image: 'https://cdn.magicpatterns.com/uploads/gq7kH7MqDxsnoHeTFf78tH/WhatsApp_Image_2026-03-27_at_7.53.20_PM.jpg'
}, {
  id: 5,
  category: 'locs',
  title: 'Faux Locs',
  description: 'Beautiful locs without long-term commitment',
  image: 'https://cdn.magicpatterns.com/uploads/dGhC96ATGVc8ngVRgcFPpR/WhatsApp_Image_2026-03-27_at_7.53.20_PM_(1).jpg'
}, {
  id: 6,
  category: 'locs',
  title: 'Butterfly Locs',
  description: 'Trendy, lightweight distressed locs',
  image: 'https://cdn.magicpatterns.com/uploads/a3c659UdAMd6Hs4w5uXHHj/WhatsApp_Image_2026-03-27_at_7.53.45_PM.jpg'
}, {
  id: 7,
  category: 'twisted',
  title: 'Senegalese Twists',
  description: 'Smooth, sleek two-strand twists',
  image: 'https://cdn.magicpatterns.com/uploads/9nRZkHQQaLf7wuD5XZhpAj/unnamed_(3).webp'
}, {
  id: 8,
  category: 'twisted',
  title: 'Passion Twists',
  description: 'Bohemian-style twists with a natural texture',
  image: 'https://cdn.magicpatterns.com/uploads/4iM6Ke2wpBnUu3H4grDgrK/unnamed.webp'
}, {
  id: 9,
  category: 'protective',
  title: 'Crochet Braids',
  description: 'Quick, versatile protective styling',
  image: 'https://cdn.magicpatterns.com/uploads/67HcVthnseTHXdQPLsyyDG/Screenshot_2026-03-19_160206.png'
}, {
  id: 10,
  category: 'protective',
  title: 'Silk Press',
  description: 'Sleek, straight finish while protecting natural hair',
  image: 'https://cdn.magicpatterns.com/uploads/sWzNLxxe1d3Tg3LRxjE2SP/Screenshot_2026-03-19_160143.png'
}, {
  id: 11,
  category: 'straight',
  title: 'Blow Out & Style',
  description: 'Professional blow dry and styling',
  image: 'https://cdn.magicpatterns.com/uploads/r6ck6bNT6WZqKUyiXHLCXL/WhatsApp Video 2026-03-27 at 8.19.30 PM.mp4'
}, {
  id: 12,
  category: 'straight',
  title: 'Flat Iron Press',
  description: 'Smooth, sleek straight look',
  image: 'https://cdn.magicpatterns.com/uploads/bmJUp6HFtTtQiY35uSMDU6/WhatsApp_Image_2026-03-27_at_7.57.48_PM.jpg'
}];
export function ServicesPage() {
  const [activeCategory, setActiveCategory] = useState('all');
  const filteredServices = activeCategory === 'all' ? services : services.filter(s => s.category === activeCategory);
  return <>
      <PageBanner title="Our Services" subtitle="Expert African hair braiding and styling tailored to your unique beauty" backgroundImage="https://cdn.magicpatterns.com/uploads/4PDBZyRMczgaLhLSyJBegB/A_close-up_image_of_a_woman_with_sleek_cornrows,_highlighting_detail_and_precision._(1).jpg" data-id="element-574" />

      <PromoOffers data-id="element-575" />

      <section className="py-20 bg-cream" data-id="element-576">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-577">
          <div className="flex flex-wrap justify-center gap-4 mb-12" data-id="element-578">
            {categories.map(category => <button key={category.id} onClick={() => setActiveCategory(category.id)} className={`px-6 py-2 rounded-full text-sm font-bold tracking-widest uppercase transition-all ${activeCategory === category.id ? 'bg-brand-gold text-cream shadow-lg scale-105' : 'bg-white text-near-black hover:bg-brand-gold/10 border border-brand-gold/20'}`} data-id="element-579">
                {category.name}
              </button>)}
          </div>

          <motion.div layout className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-580">
            <AnimatePresence mode="popLayout" data-id="element-581">
              {filteredServices.map(service => <motion.div key={service.id} layout initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} exit={{
              opacity: 0,
              scale: 0.9
            }} transition={{
              duration: 0.3
            }} className="bg-white rounded-3xl overflow-hidden shadow-sm border border-brand-gold/10 group hover:shadow-xl transition-all" data-id="element-582">
                  <div className="relative aspect-[4/3] overflow-hidden" data-id="element-583">
                    {service.image.endsWith('.mp4') ? <video src={service.image} autoPlay loop muted playsInline className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-584" /> : <img src={service.image} alt={service.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-585" />}
                  </div>
                  <div className="p-8" data-id="element-586">
                    <h3 className="font-display text-2xl text-near-black mb-2 group-hover:text-brand-gold transition-colors" data-id="element-587">
                      {service.title}
                    </h3>
                    <p className="font-body text-near-black/60 text-sm leading-relaxed mb-6" data-id="element-588">
                      {service.description}
                    </p>
                    <Button variant="outline" className="w-full" onClick={() => window.location.href = 'tel:2409217857'} data-id="element-589">
                      Book This Style
                    </Button>
                  </div>
                </motion.div>)}
            </AnimatePresence>
          </motion.div>
        </div>
      </section>

      <BookingCTA data-id="element-590" />
    </>;
}